import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {PlugStockService} from '../plug-stock.service';
import {PlugStock} from '../plugStock';
import {AddNewPlugStockDialogComponent} from '../add-new-stock-dialog/add-new-plug-stock-dialog.component';
import {BarcodeScannerService} from '../../../barcode-scanner/barcode-scanner.service';
import {SortingService} from '../../../_services/sorting.service';
import {AbstractCountComponent, BedWithVoorraad} from '../../common/abstract-count.component';

export {BedWithVoorraad};

@Component({
  selector: 'app-pot-count',
  templateUrl: './stek-count.component.html',
  styleUrls: ['./stek-count.component.scss']
})
export class StekCountComponent extends AbstractCountComponent<PlugStock> {
  protected readonly selectedPositionKey = 'stek-count-selected-position';

  constructor(
    private plugService: PlugStockService,
    route: ActivatedRoute,
    dialog: MatDialog,
    barcodeScannerService: BarcodeScannerService,
    sortingService: SortingService
  ) {
    super(route, dialog, barcodeScannerService, sortingService);
  }

  protected fetchBedNrs(): Observable<string[]> {
    return this.plugService.getBedNrs();
  }

  protected fetchStockByBedNr(bedNaam: string): Observable<PlugStock[]> {
    return this.plugService.findByLocation(bedNaam);
  }

  protected updateStockItem(stock: PlugStock): Observable<any> {
    return this.plugService.update(stock);
  }

  openAddStockDialog() {
    this.dialog.open(AddNewPlugStockDialogComponent, {
      width: '600px',
      height: '600px',
      maxWidth: '90%',
      maxHeight: '90%',
    })
      .afterClosed()
      .subscribe(() => this.onAttach());
  }
}
